import Vue from 'vue';
import basketcounter from "../components/basketcounter.vue";
import toastmessage from "../components/toastmessage.vue";


document.addEventListener("DOMContentLoaded", function() {
    initFabricSelection();
});
window.addEventListener("Pageeditor:insert", function() {
    initFabricSelection();
});
window.addEventListener("Pageeditor:change", function() {
    initFabricSelection();
});

function initFabricSelection() {

    if(document.getElementById('siteheader')) {
        new Vue({
            name: 'SiteHeader',
            el: '#siteheader',
            components: {
                basketcounter,
                toastmessage
            },
            methods: {

            }
        });
    }
}